import { eventbus } from "../eventbus";

export const dayEventChannel = eventbus<{
  onUpdateDayTask: (payload?) => void;
}>();
